import type { RequestStatus } from './controlTowerApi';
import { controlTowerApi } from './controlTowerApi';

export type DatePreset = 'standard' | 'pickup_next_week' | 'delivery_two_days_later';
export type PickupPreset = 'matching' | 'two_hours_later' | 'one_day_later' | 'one_day_earlier';
export type Signal = 'request' | 'transports';
export type DemoCommand = {
    request_id: string;
    chain_created_at: string;
    date_preset: DatePreset;
    planned_transport_count: number;
    planned_request_count?: number;
    request_index?: number;
    transport_index: number;
    pickup_preset: PickupPreset;
    request_status?: RequestStatus;
    revision?: number;
    deleted?: boolean;
};
export type PublicationReceipt = {
    request_id: string;
    entity_id: string;
    event_id: string;
    revision: number;
    command: DemoCommand;
    requested_pickup: { date: string; time?: string };
    requested_delivery: { date: string; time?: string };
    status: 'published';
};
export type SnapshotCommand = { snapshot: Record<string, unknown>; revision?: number; occurred_at?: string };
export type SnapshotReceipt = { entity_id: string; event_id: string; revision: number; status: 'published' };
export const scmMockApi = controlTowerApi.injectEndpoints({
    endpoints: builder => ({
        publishSnapshot: builder.mutation<
            SnapshotReceipt,
            { resource: 'transport-requests' | 'transports'; id: string; command: SnapshotCommand }
        >({
            query: ({ resource, id, command }) => ({
                url: `/api/scm-mock/${resource}/${encodeURIComponent(id)}`,
                method: 'PUT',
                body: command,
            }),
            invalidatesTags: ['TransportData'],
        }),
        clearDemoData: builder.mutation<{ status: 'cleared' }, { confirmation: 'DELETE_ALL_DEMO_DATA' }>({
            query: command => ({ url: '/api/scm-mock/data', method: 'DELETE', body: command }),
            invalidatesTags: ['TransportData'],
        }),
        publishSignal: builder.mutation<PublicationReceipt, { signal: Signal; command: DemoCommand }>({
            query: ({ signal, command }) => ({
                url: `/api/scm-mock/${signal === 'request' ? 'transport-requests' : 'transports'}`,
                method: 'POST',
                body: command,
            }),
        }),
    }),
});
export const { usePublishSignalMutation, useClearDemoDataMutation, usePublishSnapshotMutation } = scmMockApi;
